module.exports = __webpack_public_path__ + "img/icn_report_appointment.69095205.svg";